import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { Chart, registerables } from 'chart.js';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';

Chart.register(...registerables);

@Component({
  selector: 'app-capex-required-chart',
  templateUrl: './capex-required-chart.component.html',
  styleUrls: ['./capex-required-chart.component.scss'],
})
export class CapexRequiredChartComponent implements OnInit, OnChanges, OnDestroy {
  @Input() capexData: any;
  @Input() showHeader: any;
  @Input() showTimeFrameModeToggle = true;
  public chartObj;
  public enableWaterfallGraph: false;
  public aggregatedData = [];
  public regionKeys: any = [];

  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  public timeFrameMode: TimeFrameMode;
  public chartParams = [];
  public chartData = {
    year: {},
    quarter: {},
  };

  private subs = new Subscription();

  constructor(
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.timeFrameMode) {
      this.prepareChart();
      this.aggregatedData = this.aggregator();
    }
  }

  ngOnInit(): void {
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        if (filter) {
          this.yearRange.startYear = filter.start_year;
          this.yearRange.endYear = filter.end_year;
        }
      }),
    );
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
        this.prepareChart();
        this.aggregatedData = this.aggregator();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onTimeFrameChange(value: TimeFrameMode) {
    this.mondelezDataService.updateTimeFrameMode(value);
  }

  private prepareChart() {
    this.chartParams = [];
    this.regionKeys = Object.keys(this.capexData['year']).filter((ele) => ele != 'total');
    // const backgroundColors = ['#421C5D', '#6C4688', '#A68FB7', '#E1E1E6'];
    const backgroundColors = ['#2E2E38', '#747480', '#C4C4CD', '#E1E1E6'];
    this.regionKeys.forEach((key, index) => {
      this.chartParams.push({
        name: key,
        type: 'bar',
        label: key
          .split('_')
          .map((el) => el.charAt(0).toUpperCase() + el.slice(1))
          .join(' '),
        color: backgroundColors[index],
        stacked: true,
        legend: { isTop: true, isRight: false },
      });
      this.chartData[this.timeFrameMode][key] = this.capexData[this.timeFrameMode][key];
    });
  }

  private calculateVals(type) {
    return this.capexData[this.timeFrameMode][type].map((el) => this.formatNumbers(el));
  }

  private formatNumbers(amt: number) {
    if (!amt) return 0;
    let millionth = amt / 1000000;

    return Math.round(millionth * 10) / 10;
  }

  private aggregator() {
    const countryList = Object.keys(this.capexData[this.timeFrameMode]);
    const aggData = countryList.map((el) => {
      const sum = this.capexData[this.timeFrameMode][el].reduce((sum, item) => (sum = sum + item), 0);
      el = el.replaceAll('_', ' ');

      return { label: el, value: this.formatNumbers(sum), prefix: '$', suffix: 'MM' };
    });

    return aggData;
  }
}
